module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.displayNavbar) ? _c('header', {
    staticClass: "app-header navbar"
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6449f348"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/containerComponents/Navbar.vue
// module id = 1021
// module chunks = 1